'use strict';

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.jQuery = require('jquery');
    window._ = require('lodash');
    window.Popper = require('popper.js').default;
    window.swal = require('sweetalert');

    require('bootstrap');

    let ClipboardJS = require('clipboard');
    var clipboard = new ClipboardJS('.btn-clipboard');
    var fadeTimer;

    clipboard.on('success', function(e) {
        var feedback = $(e.trigger).parent().siblings('.clipboard-feedback');
        feedback.show();

        clearTimeout(fadeTimer);
        fadeTimer = setTimeout( function(){ feedback.fadeOut(); } , 3000);

        e.clearSelection();

        /* Infos ueber die Variable e
         *
         * console.info('Action:', e.action);
         * console.info('Text:', e.text);
         * console.info('Trigger:', e.trigger);
         */
     });
/*
clipboard.on('error', function(e) {
    console.error('Action:', e.action);
    console.error('Trigger:', e.trigger);
});
*/
} catch (e) {}

window.xclose = function() {try{API.LMSFinish('');return;}catch(e){}try{API_1484_11.Terminate('');return;}catch(e){}}
window.openWorld = function() {}

$(window).on("popstate", function() {
    var anchor = location.hash || $("a[data-toggle='tab']").first().attr("href");
    $("a[href='" + anchor + "']").tab("show");
});

$(function(){

    /*
     * MAIN NAVIGATION
     */

    $.navigation = $('nav > ul.nav');

    // Add class .active to current link
    $.navigation.find('a.active').each(function(){

        $(this).parents('ul').add(this).each(function(){
            $(this).parent().addClass('open');
        });
    });

    // Dropdown Menu
    $.navigation.on('click', 'a', function(e){

        if ($.ajaxLoad) {
            e.preventDefault();
        }

        if ($(this).hasClass('nav-dropdown-toggle')) {
            $(this).parent('.nav-dropdown').toggleClass('open');
            resizeBroadcast();
        }
    });

    function resizeBroadcast() {

        var timesRun = 0;
        var interval = setInterval(function(){
            timesRun += 1;
            if(timesRun === 5){
                clearInterval(interval);
            }
            window.dispatchEvent(new Event('resize'));
        }, 62.5);
    }

    /* ---------- Main Menu Open/Close, Min/Full ---------- */
    $('.sidebar-toggler').click(function(){
        $('body').toggleClass('sidebar-hidden');
        resizeBroadcast();
    });

    $('.sidebar-minimizer').click(function(){
        $('body').toggleClass('sidebar-minimized');
        var state = $('body').hasClass('sidebar-minimized');
        axios.post(laroute.route('sessions.store'), {
            key: "SidebarMinimized",
            value: state
        });
        resizeBroadcast();
    });

    $('.brand-minimizer').click(function(){
        $('body').toggleClass('brand-minimized');
    });

    $('.aside-menu-toggler').click(function(){
        $('body').toggleClass('aside-menu-hidden');
        resizeBroadcast();
    });

    $('.mobile-sidebar-toggler').click(function(){
        $('body').toggleClass('sidebar-mobile-show');
        resizeBroadcast();
    });

    $('.sidebar-close').click(function(){
        $('body').toggleClass('sidebar-opened').parent().toggleClass('sidebar-opened');
    });

});

/* POLYFILL */
(function templatePolyfill(d) {
    if('content' in d.createElement('template')) {
        return false;
    }

    var qPlates = d.getElementsByTagName('template'),
        plateLen = qPlates.length,
        elPlate,
        qContent,
        contentLen,
        docContent;

    for(var x=0; x<plateLen; ++x) {
        elPlate = qPlates[x];
        qContent = elPlate.childNodes;
        contentLen = qContent.length;
        docContent = d.createDocumentFragment();

        while(qContent[0]) {
            docContent.appendChild(qContent[0]);
        }

        elPlate.content = docContent;
    }
})(document);